import ReaddyForm, { type FormField } from '@/components/feature/ReaddyForm';
import SectionHeading from '@/components/base/SectionHeading';

const tipFields: FormField[] = [
  {
    name: 'alias',
    label: '称呼或化名',
    type: 'text',
    placeholder: '可留空，我们会以“投稿人”称呼你',
    half: true,
    maxLength: 40,
  },
  {
    name: 'email',
    label: '联系邮箱',
    type: 'email',
    placeholder: '可留空，如需回复请填写',
    half: true,
    hint: '仅用于回复与补充核实，不会对外公开。',
  },
  {
    name: 'preferred_channel',
    label: '希望的联系方式',
    type: 'select',
    options: ['加密邮箱', 'Telegram 即时沟通', '暂不需要回复'],
  },
  {
    name: 'category',
    label: '线索类别',
    type: 'select',
    options: ['公共事务与政务', '商业观察与企业', '科技与数据', '城市与民生', '其他'],
  },
  {
    name: 'content',
    label: '线索简述',
    type: 'textarea',
    required: true,
    placeholder:
      '请尽量说明时间、地点、涉及主体与你能提供的第一手依据。不必写成完整文章，把事情说清楚即可。',
    hint: '最多 500 字。请勿在此填写他人隐私信息。',
  },
];

const guarantees = [
  { icon: 'ri-fingerprint-line', text: '匿名提交不采集真实 IP 与浏览器指纹' },
  { icon: 'ri-shield-check-line', text: '材料在进入核查前完成去标识化处理' },
  { icon: 'ri-user-unfollow-line', text: '你可以在任何阶段中止沟通，无需说明理由' },
  { icon: 'ri-lock-2-line', text: '内容仅限线索处理小组范围内的最小知情者查阅' },
];

export default function TipFormSection() {
  return (
    <section id="submit" className="bg-background-100 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <SectionHeading
              kicker="Submit A Tip"
              title="匿名提交一条线索"
              description="这是最轻量的投稿方式，无需注册、无需署名。请先确保你所在的环境安全，再决定提供到什么程度。"
            />

            <ul className="mt-8 space-y-4">
              {guarantees.map((item) => (
                <li key={item.text} className="flex items-start gap-3.5">
                  <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-700 pt-2">{item.text}</p>
                </li>
              ))}
            </ul>

            <div className="mt-8 bg-background-50 border border-foreground-950/10 rounded-lg p-5">
              <p className="font-mono text-xs tracking-[0.16em] uppercase text-foreground-500">
                更安全的替代方式
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                若你掌握的是可识别到具体个人的敏感材料，建议改用加密邮箱 xiansuo@shentong-baoliao.com，
                并使用 PGP 公钥加密后再发送。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-background-50 border border-foreground-950/10 rounded-lg p-6 md:p-8">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                线索提交表单
              </h3>
              <p className="mt-2 text-sm text-foreground-600">
                带 <span className="text-primary-500">*</span> 的为必填项，其余均可留空。
              </p>
              <div className="mt-6">
                <ReaddyForm
                  formId="tip-submit-form"
                  submitAddr="https://readdy.ai/api/form/dah87kboh653ivfvno10"
                  fields={tipFields}
                  honeypotName="contact_alt"
                  submitLabel="匿名提交线索"
                  successText="已收到你的线索，感谢你的信任。如需核实，我们会通过你留下的方式联系。"
                  note="提交前请再次确认内容中不含无关他人的隐私信息。"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}